import {
  matchesStatus,
  type StatusFilter,
} from '@/components/carry-documents/carryDocumentStatus';
import type { CarryDocumentStatus } from '@/types/carryDocument';
import type { CarryDocument } from '../services/carryService';

export const AWAITING_YOUR_SIGNATURE =
  'These documents are waiting for your signature';

export type StatusSort = 'none' | 'asc' | 'desc';

// Ascending puts what needs the member's attention first.
const STATUS_ORDER: Record<CarryDocumentStatus, number> = {
  AWAITING_SIGNATURE: 0,
  MISSING: 1,
  SIGNED: 2,
};

export function nextStatusSort(sort: StatusSort): StatusSort {
  if (sort === 'none') return 'asc';
  if (sort === 'asc') return 'desc';
  return 'none';
}

export function filterAndSortDocuments(
  documents: CarryDocument[],
  statusFilter: StatusFilter,
  statusSort: StatusSort
): CarryDocument[] {
  const filtered = documents.filter((d) =>
    matchesStatus(d.status, statusFilter)
  );
  if (statusSort === 'none') return filtered;
  const direction = statusSort === 'asc' ? 1 : -1;
  return [...filtered].sort(
    (a, b) => (STATUS_ORDER[a.status] - STATUS_ORDER[b.status]) * direction
  );
}
